import { render, staticRenderFns } from "./refunds.vue?vue&type=template&id=eb2cedae&scoped=true&"
import script from "./refunds.vue?vue&type=script&lang=js&"
export * from "./refunds.vue?vue&type=script&lang=js&"
import style0 from "./refunds.vue?vue&type=style&index=0&id=eb2cedae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2cedae",
  null
  
)

export default component.exports